export function remove(name: string): void {
    const url = new URL(location.href);
    if (url.searchParams.has(name)) {
        url.searchParams.delete(name);
        window.history.replaceState({}, document.title, url.toString());
    }
}
